import './EventStatWidgetEditDialog.scss';

import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import TextField from "../../../1. Core/Controls/TextField/TextField";
import NP from "../../../1. Core/NP";
import {getTournaments, ITournament} from "../../Util";
import {EventStatWidgetMetadata, EventTournament, SportType, Widget} from "../../types";
import {ServerAPI} from "../../../1. Core/ServerAPI";
import Button from "../../../1. Core/Controls/Button/Button";
import {WidgetType} from "../WEnum";
import Select from "../../../1. Core/Controls/Select/Select";


export default class EventStatWidgetEditDialog extends Dialog {
	private _name: TextField;
	private _promoLogoUrlInput: TextField;
	private _sponsorLogoUrlInput: TextField;
	private _backgoundUrlInput: TextField;

	private _eventCombo: Select;
	private _tournamentCombo: Select;

	private _Widget: Widget<EventStatWidgetMetadata>;
	private _download1x1: Button;
	private _download9x16: Button;
	private _download16x9: Button;
	private _previewFrame: HTMLFrameElement;
	private _timeId: any;
	private _tEvents: EventTournament[];
	private _Event: EventTournament;

	_initFields(settings: object)
	{
		this._Event = null;
		this._Widget = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('Event');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
		this._AutoDestroy = true;
		this._Width = 1600;
	}

	_render()
	{
		super._render();

		let flexNode = NP.createNode(this._contentNode, 'widget-dlg-content-node')
		let leftNode = NP.createNode(flexNode, 'widget-dlg-settings-node')
		this._contentDomNode.style.maxWidth = '1600px'

		this._name = new TextField({
			FloatingLabel: NP.RM.getString('Name'),
			ParentNode: leftNode
		});

		this._backgoundUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('Background'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._promoLogoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('PromoLogo'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._sponsorLogoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('SponsorLogo'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._tournamentCombo = new Select({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('Tournament'),
			EvItemSelected: () => this.updateEvents()
		});

		this._eventCombo = new Select({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('Event'),
			EvItemSelected: () => this.onSettingsChanged()
		});

		this._previewFrame = NP.createNode(flexNode, '', 'iframe');

		if (this._Widget)
		{
			this._name.setValue(this._Widget.Name)
			this._backgoundUrlInput.setValue(this._Widget.Metadata.Background)
			this._promoLogoUrlInput.setValue(this._Widget.Metadata.PromoLogo)
			this._sponsorLogoUrlInput.setValue(this._Widget.Metadata.SponsorLogo)
		}


		this._download1x1 = new Button({
			ParentNode: leftNode,
			Content: NP.RM.getString('Download') + ' 1x1',
			EvClick: () =>
			{
				let baseUrl = encodeURIComponent(`${NP.Config.Origin}cwidget?id=${this._Widget.Id}&lang=${NP.getCurrentCulture().Name}&hidecb=true`)
				NP.downloadFile(`${NP.Config.ExportURL}?name=widget.png&type=png&w=1080&h=900&base_url=${baseUrl}`);
			}
		});

		this._download9x16 = new Button({
			ParentNode: leftNode,
			Content: NP.RM.getString('Download') + ' 9x16',
			EvClick: () =>
			{
				let baseUrl = encodeURIComponent(`${NP.Config.Origin}cwidget?id=${this._Widget.Id}&lang=${NP.getCurrentCulture().Name}&mode=9x16&hidecb=true`)
				NP.downloadFile(`${NP.Config.ExportURL}?name=widget.png&type=png&w=1080&h=2012&base_url=${baseUrl}`);
			}
		});

		this._download16x9 = new Button({
			ParentNode: leftNode,
			Content: NP.RM.getString('Download') + ' 16x9',
			EvClick: () =>
			{
				let baseUrl = encodeURIComponent(`${NP.Config.Origin}cwidget?id=${this._Widget.Id}&lang=${NP.getCurrentCulture().Name}&mode=16x9&hidecb=true`)
				NP.downloadFile(`${NP.Config.ExportURL}?name=widget.png&type=png&w=1920&h=1151&base_url=${baseUrl}`);
			}
		});

		if (!this._Widget)
		{
			this._Widget = {
				Metadata: {WId: WidgetType.EventStat}
			} as Widget<EventStatWidgetMetadata>


			if (this._Event)
			{
				this._Widget.Metadata.TournamentId = this._Event.TournamentId
				this._Widget.Metadata.EventId = this._Event.Id;
				this._name.setValue(this._Event.Name);
			}
		}
		this.refresh()
	}

	onSettingsChanged()
	{
		if (this._timeId)
			clearTimeout(this._timeId);

		this._timeId = setTimeout(() => this.updatePreview(), 200);
	}

	updateObjSettings()
	{
		this._Widget.Name = this._name.getValue();
		this._Widget.Metadata.Background = this._backgoundUrlInput.getValue()
		this._Widget.Metadata.PromoLogo = this._promoLogoUrlInput.getValue()
		this._Widget.Metadata.SponsorLogo = this._sponsorLogoUrlInput.getValue()
		this._Widget.Metadata.EventId = this._eventCombo.getValue();
		this._Widget.Metadata.TournamentId = this._tournamentCombo.getValue();

		this._Widget.Metadata.TournamentName = (this._tournamentCombo.getSelectedItem()?.Value as ITournament)?.Name
		this._Widget.Metadata.EventName = (this._eventCombo.getSelectedItem()?.Value as EventTournament)?.Name
	}

	updatePreview()
	{
		this.updateObjSettings();

		if (this._Widget.Metadata.EventId)
			this._previewFrame.src = `/cwidget/event-stat?id=${this._Widget.Id || -1}&lang=${NP.getCurrentCulture().Name}&json=${encodeURIComponent(JSON.stringify(this._Widget))}`
	}

	async refresh()
	{

		let tList = await getTournaments(SportType.MMA) as ITournament[]


		let items = tList.map(t => ({Value: t.Id, FontImage: NP.FontImages.integration, Content: t.Name, Data: t}));
		this._tournamentCombo.setItems(items);


		if (this._Widget && this._Widget.Metadata.EventId)
		{
			this._tournamentCombo.setValue(this._Widget.Metadata.TournamentId, false)
			await this.updateEvents(this._Widget.Metadata.TournamentId);
			this._eventCombo.setValue(this._Widget.Metadata.EventId, false);
			this.updatePreview()
		}
		else
		{
			if (tList[0])
			{
				this._tournamentCombo.setValue(tList[0].Id)
				this.updateEvents();
			}
		}
	}

	async updateEvents(tId: number = null)
	{
		let response = await ServerAPI.callUiApi("/t-events", {
			Count: 500,
			Offset: 0,
			TournamentId: tId || this._tournamentCombo.getValue()
		}, 'POST') as { List: EventTournament[], AllCount: number };
		this._tEvents = response.List;
		this._eventCombo.setItems(response.List.map(ev => ({Content: ev.Name, Value: ev.Id})));
	}


	async _onOkButtonClick()
	{
		if (!this._name.getValue().trim() || !this._eventCombo.getValue())
			return;

		this.updateObjSettings();

		if (this._Widget.Id)
			await ServerAPI.callUiApi(`/widget/${this._Widget.Id}`, this._Widget, 'POST');
		else
			await ServerAPI.callUiApi("/widget", this._Widget, 'PUT')


		this.EvOkButtonClick.fire(this);
		this.hide();
	}
}